<i18n>
{
  "en": {
    "label": {
      "userComment": "Comment",
      "changeComment": "Change comment"
    },
    "message": {
      "header": "Since you are currently reviewing data, you can only change comments and add files. Please note that if you change the comment, the previous comment will be deleted. It is impossible to delete already submitted files.",
      "description": "Please enter a new comment."
    },
    "alert": {
      "confirmUpdateComment": "Will update the comment with the content described. Is it OK?",
      "doneUpdate": "Update completed",
      "donePost": "Submission completed",
      "uploadError": "Could not send correctly. Please try again later or contact us if you experience repeated errors."
    }
  },
  "ja": {
    "label": {
      "userComment": "コメント/メモ",
      "changeComment": "コメントを変更"
    },
    "message": {
      "header": "現在データを確認中のため、コメントの変更とファイルの追加のみ可能です。コメントの変更を行った場合、前回のコメントは削除されますので、ご注意ください。既に提出済みのファイルの削除は不可能です。",
      "description": "変更後のコメントを入力してください（現在のコメントが表示されています）"
    },
    "alert": {
      "confirmUpdateComment": "記載の内容でコメントを更新します。よろしいですか？",
      "doneUpdate": "更新が完了しました",
      "donePost": "送信が完了しました",
      "uploadError": "正しく送信できませんでした。時間を置いてお試しいただくか、繰り返しエラーが発生する場合はお問い合わせをお願いいたします。"
    }
  }
}
</i18n>

<template>
  <div class="upload-form-wrapper" style="justify-content: center;">
    <v-container style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
      <v-alert
        outline
        :value="true"
        color="success"
        icon="info"
        class="text-sm-left mb-3"
        style=" max-width: 640px;"
      >
        {{ this.$t('message.header') }}
      </v-alert>
      <div slot="label" style="text-align: left; width: 100%; max-width: 640px;">
        {{ this.$t('message.description') }}
      </div>
      <div style="width: 100%; max-width: 640px;">
        <TextAreaInput
          name="userComment"
          v-model="userComment"
          :placeholderValue="this.$t('label.userComment')"
        >
        </TextAreaInput>
      </div>
      <v-btn color="primary" @click="updateComment">
        {{ $t('label.changeComment') }}
      </v-btn>
    </v-container>
  </div>
</template>

<script>
import TextAreaInput from '@/components/atoms/TextAreaInput.vue';
import { Me } from '@/api';
import subOptionHandler from '@/helper/subOptionHandler.js';
import { EnumSubmissionType } from '@/enum/enum.js';
import StorageManager from '@/utils/StorageManager';

export default {
  components: {
    TextAreaInput
  },
  props: {
    submission: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      mySubmission: {},
      EnumSubmissionType: EnumSubmissionType,
      userComment: '',
      isLoading: false
    };
  },
  watch: {
    submission: function(newVal) {
      this.userComment = newVal.userComment;
      this.mySubmission = Object.assign({}, newVal);
    }
  },
  methods: {
    /**
     * EnumのTypeとCodeとlocaleからEnumの文字列を返却
     * @param String type EnumのType
     * @param Integer code EnumのCode
     */
    getEnumStr(type, code) {
      return this.$store.getters.getEnumByCode({ type, code });
    },
    reload() {
      this.$router.go();
    },
    updateComment() {
      if (this.userComment === '') {
        alert('コメントが空欄です');
        return;
      }
      if (window.confirm(this.$t('alert.confirmUpdateComment'))) {
        //this.isLoading = true;
        Me.patchUserComment(this.mySubmission.id, this.userComment)
          .then(() => {
            //alert(this.$t('alert.doneUpdate'));
            this.reload();
          })
          .catch(() => {
            alert(this.$t('alert.uploadError'));
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    getCampaignCode: () => {
      return StorageManager.getItem('CAMPAIGN_CODE_SESSION_KEY');
    }
  },
  computed: {
  }
};
</script>

<style lang="stylus" scoped>
.upload-form-wrapper
    background-color: white;
    padding: 10px;
    width: 100%;
    min-height: 300px;
    height: 50%;
    text-align: center;
</style>
